import { Box, Menu, MenuButton, Flex, MenuList, Text, MenuDivider, MenuItem, Icon } from "@chakra-ui/react";
import { HiLocationMarker } from "react-icons/hi";
import { useState, useRef, useEffect } from "react";
import * as turf from '@turf/turf';
import { useMap } from "react-map-gl";

export const RegionSelectMenu = (props) => {
    const { regionsGeoJson, mapLocation } = props;

    // Preventing first region select menu item from highlighting by default
    const nullRef = useRef();
    const { current: map } = useMap();
    const [selectedRegionName, setSelectedRegionName] = useState(null);
    const [isMenuRegionSelected, setIsMenuRegionSelected] = useState(false);
    const regionGeoJson = regionsGeoJson.data?.regions?.find((region => region.name === selectedRegionName));

    // Moves to the region position on the map when selected in the top bar
    useEffect(() => {
        if (selectedRegionName) {
            map.flyTo({ center: [regionGeoJson.centroid.longitude, regionGeoJson.centroid.latitude], zoom: 6.5 });
            setIsMenuRegionSelected(false);
        }
    }, [isMenuRegionSelected]);

    // Need to expand the geoJson polygon area for it to fit in the pin position
    const dilatePolygon = (polygon, scaleFactor) => {
        const centroid = turf.centroid(polygon);
        return turf.transformTranslate(turf.transformScale(polygon, scaleFactor), centroid.geometry.coordinates[0], centroid.geometry.coordinates[1]);
    }

    // Dilated each regions polygon differently depending on its needs
    useEffect(() => {
        if (Object.keys(mapLocation)?.length !== 0) {
            const visibleRegionName = regionsGeoJson.data?.regions?.find((region) => {
                const dilationValue = (() => {
                    switch (region.id) {
                        case 'cook-inlet':
                            return 1;
                        case 'bering-sea':
                            return 2;
                        default:
                            return 3.5;
                    }
                })();

                return region.features.some(feature => {
                    return turf.booleanPointInPolygon(
                        turf.point([mapLocation?.coordinates?.longitude, mapLocation?.coordinates?.latitude]),
                        dilatePolygon(feature, dilationValue)
                    );
                });
            })?.name;

            // Prevents region changing when too zoomed out on map
            if (mapLocation.zoom >= 6.5) {
                setSelectedRegionName(visibleRegionName)
            } else {
                setSelectedRegionName(null)
            }
        }
    }, [mapLocation]);

    return (
        <Box id="regionSelect" position={'absolute'} width={'100%'} backgroundColor={'white'} zIndex={12}>
            <Menu initialFocusRef={nullRef}>
                <MenuButton paddingY={2.5}>
                    <Flex alignItems={'center'} fontSize={16} gap={1} fontWeight={500}>
                        <Icon as={HiLocationMarker} boxSize={5} color={'gray.400'} />
                        <Text>{!selectedRegionName ? 'Select Region' : selectedRegionName}</Text>
                    </Flex>
                </MenuButton>
                <MenuList padding={4} fontSize={16}>
                    <Text fontWeight={700} textAlign={'left'} pl={'12px'} color={'gray.700'}>Select Region</Text>
                    <MenuDivider />
                    {regionsGeoJson.data?.regions?.map((region) => (
                        <MenuItem
                            color={'gray.700'}
                            width={'fit-content'}
                            key={region.id}
                            _hover={{ bg: 'teal.100' }}
                            _focus={{ bg: 'teal.100' }}
                            _active={{ bg: 'teal.100' }}
                            borderRadius="99px"
                            fontWeight={600}
                            value={selectedRegionName === null ? 'Select Region' : selectedRegionName}
                            onClick={() => { setIsMenuRegionSelected(true); setSelectedRegionName(region.name); }}
                        >
                            {region.name}
                        </MenuItem>
                    ))}
                </MenuList>
            </Menu>
        </Box>
    )
}